/*
<summary>
   This file defines the filter shape shared by both Equipment Inspection Menu tabs (User
   Created and Crimp Inspection) - the same fields drive both
   ToolManagement/GetUserInspectedList and ToolManagement/GetCrimpToolInspectionList (and
   their matching CSV export endpoints).
   Developer: Aashish Singh, Created Date: 01-Sep-2026
</summary>
*/

export interface ISharedInspectionFilter {
  OwnerFactoryId: number;
  ToolManagementNo: string;
  ToolName: string;
  InspectionDateFrom: string;
  InspectionDateTo: string;
  JudgmentResult: string;
}

export const SharedInspectionFilterInitialState: ISharedInspectionFilter = {
  OwnerFactoryId: -1,
  ToolManagementNo: '',
  ToolName: '',
  InspectionDateFrom: '',
  InspectionDateTo: '',
  JudgmentResult: '',
};
